import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials sends and receives httpOnly auth cookie automatically.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const endpoints = {
  login: (data) => api.post("/auth/login", data),
  logout: () => api.post("/auth/logout"),
  me: () => api.get("/auth/me"),
  list: (resource) => api.get(`/${resource}`),
  get: (resource, id) => api.get(`/${resource}/${id}`),
  create: (resource, data) => api.post(`/${resource}`, data),
  update: (resource, id, data) => api.put(`/${resource}/${id}`, data),
  remove: (resource, id) => api.delete(`/${resource}/${id}`),
  dashboard: () => api.get("/dashboard/stats"),
  reports: () => api.get("/reports/summary"),
  activities: () => api.get("/activities"),
  settings: () => api.get("/settings"),
  updateSettings: (data) => api.put("/settings", data),
  nextInvoiceNumber: () => api.get("/utils/next-invoice-number"),
};
